import React from 'react';
import {connect} from 'react-redux';
import {NavLink} from 'react-router-dom';
import SideImage from '../assets/images/sidebar_img.png'

const Sidebar = (props) => {

    return (
        <nav className={props.expanded ? "main-menu expanded" : "main-menu"}>
            {/* <img className="img-fluid" src={SideImage}/> */}
            <ul className="sidebar-list">
                <li className="sidebar-list-item">
                    <NavLink to="/" exact={true} className="sidebar__item" activeClassName="sidebar__item__active">
                        <i className="material-icons nav-icon fa">star</i>
                        <span className="nav-text">خانه</span>
                    </NavLink>
                </li>
                {
                    props.isLogin ? (
                        <>
                            <li className="sidebar-list-item">
                                <NavLink to="/dashboard" className="sidebar__item" activeClassName="sidebar__item__active">
                                    <i className="material-icons nav-icon fa">account_circle</i>
                                    <span className="nav-text">پروفایل</span>
                                </NavLink>
                            </li>
                            <li className="sidebar-list-item">
                                <NavLink to="/register-vehicle" className="sidebar__item" activeClassName="sidebar__item__active">
                                    <i className="material-icons nav-icon fa">assignment</i>
                                    <span className="nav-text">درج آگهی</span>
                                </NavLink>
                            </li>
                            <li className="sidebar-list-item">
                                <NavLink to="/register-job" className="sidebar__item" activeClassName="sidebar__item__active">
                                    <i className="material-icons nav-icon fa">assessment</i>
                                    <span className="nav-text">درج مشاغل</span>
                                </NavLink>
                            </li>
                        </>
                    ) : (
                        <li className="sidebar-list-item">
                            <NavLink to="/login" className="sidebar__item" activeClassName="sidebar__item__active">
                                <i className="material-icons nav-icon fa">account_circle</i>
                                <span className="nav-text">ورود</span>
                            </NavLink>
                        </li>
                    )
                }
                
                <li className="sidebar-list-item">
                    <NavLink to="/vehicles" className="sidebar__item" activeClassName="sidebar__item__active">
                        <i className="material-icons nav-icon fa">add_shopping_cart</i>
                        <span className="nav-text">خرید</span>
                    </NavLink>
                </li>
                <li className="sidebar-list-item">
                    <NavLink to="/jobs" className="sidebar__item" activeClassName="sidebar__item__active">
                        <i className="material-icons nav-icon fa">insert_photo</i>
                        <span className="nav-text">مشاغل</span>
                    </NavLink>
                </li>
                <li className="sidebar-list-item">
                    <NavLink to="/agencies" className="sidebar__item" activeClassName="sidebar__item__active">
                        <i className="material-icons nav-icon fa">insert_chart</i>
                        <span className="nav-text">نمایندگی</span>
                    </NavLink>
                </li>
                <li className="sidebar-list-item">
                    <NavLink to="/galleries" className="sidebar__item" activeClassName="sidebar__item__active">
                        <i className="material-icons nav-icon fa">note</i>
                        <span className="nav-text">نمایشگاه</span>
                    </NavLink>
                </li>
                <li className="sidebar-list-item">
                    <NavLink to="/about-us" className="sidebar__item" activeClassName="sidebar__item__active">
                        <i className="material-icons nav-icon fa">assignment_ind</i>
                        <span className="nav-text">درباره ما</span>
                    </NavLink>
                </li>
            </ul>
        </nav>
    );
}

const mapStateToProps = (state, props) => ({
    isLogin: !!state.auth.token
})

export default connect(mapStateToProps)(Sidebar);